import styled from 'styled-components';

export const StyledCreatePatientPersonalData = styled.div`
   padding-right: 12px;
   display: flex;
   flex-direction: column;
   gap: 18px;
`;
StyledCreatePatientPersonalData.displayName = 'StyledCreatePatientPersonalData';
